module.exports = __webpack_public_path__ + "18b79587730e8b82edf5a1fa6e030ace.png";